export default from './RelatedTransaction';



// WEBPACK FOOTER //
// ./src/components/case/related_transaction/index.js